import { render, staticRenderFns } from "./CallsHistory.vue?vue&type=template&id=8cc638b0&scoped=true&"
import script from "./CallsHistory.vue?vue&type=script&lang=js&"
export * from "./CallsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc638b0",
  null
  
)

export default component.exports